// tool.js

import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';
import { numeral } from '@fund/basic-lib/dist/lib/numeral';
// 获取星期几
function getWeekFromDate(dateStr) {
  const num = new Date(dateStr).getDay();
  const weekDateList = [
    '星期日',
    '星期一',
    '星期二',
    '星期三',
    '星期四',
    '星期五',
    '星期六',
  ];
  return weekDateList[num];
}

// 分割时间
function splitDateTime(dateStr) {
  if (!dateStr) {
    return '--';
  }
  const arr = dateStr.split(/[- :]/);

  if (arr.length === 6) { return new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]); }
  if ((arr.length === 3)) { return new Date(arr[0], arr[1] - 1, arr[2]); }
  return '--';
}

function getRateColor(rate) {
  const value = parseFloat(rate);
  if (value < 0) return '#12b412';
  if (value > 0) return '#ff0000';
  return '#000000';
}

// 16位色值转rgba
function hexToRgba(hex, opacity) {
  return `rgba(${parseInt(`0x${hex.slice(1, 3)}`, 16)},${
    parseInt(`0x${hex.slice(3, 5)}`, 16)},${
    parseInt(`0x${hex.slice(5, 7)}`, 16)},${
    opacity})`;
}
// 获取距今的天数
function getDaysToNow(date) {
  const dateTime = Date.parse(date?.replace(/-/g, '/'));
  const dateNow = new Date().getTime();
  return Math.floor((dateNow - dateTime) / (24 * 60 * 60 * 1000));
}

function formateBigNumber(value, toFixedCount = 2) {
  const num = parseFloat(value);
  if (num >= 100000000) { // 亿
    const prefix = (num / 100000000).toFixed(toFixedCount);
    return `${prefix}亿`;
  } if (num >= 10000000) { // 千万
    const prefix = (num / 10000000).toFixed(toFixedCount);
    return `${prefix}千万`;
  } if (num >= 1000000) { // 百万
    const prefix = (num / 1000000).toFixed(toFixedCount);
    return `${prefix}百万`;
  } if (num >= 10000) { // 万，小程序代码里没有"十万"
    const prefix = (num / 10000).toFixed(toFixedCount);
    return `${prefix}万`;
  }
  return value;
}

// 四舍五入
function formateFixedNumber(value, count) {
  if (isEmpty(value)) return '--';
  const factor = 10 ** count;
  return (Math.round(value * factor) / factor).toFixed(count);
}

function dateFromString(time) {
  if (!time) { return null; }
  let newTime = time;
  newTime = newTime.replace(new RegExp('T', 'g'), ' ');
  if (newTime.length > 19) {
    newTime = newTime.substring(0, 19);
  }
  const timeArr = newTime.split(' ');
  const firstArr = timeArr[0].split('-'); // 长度3 年 月 日
  const secondArr = timeArr[1].split(':'); // 长度3 时 分 秒
  if (!secondArr[2]) { secondArr[2] = '00'; }
  const date = new Date(
    firstArr[0], firstArr[1] - 1, firstArr[2], secondArr[0], secondArr[1], secondArr[2],
  );
  const result = [firstArr, secondArr, date];
  return result;
}

// 将 yyyy-MM-dd hh:mm:ss 格式的时间字符串转化
// 如果是当天，显示今天，如果是小于23小时，显示几小时前，其他的显示MM-dd
function formatDateTime(time, isOnlyData = false) {
  if (time === '') { return ''; }
  const result = dateFromString(time);
  if (!result || result?.length < 3 || !result[2]) { return ''; }
  const date = result[2];
  let resTime = ''; // 返回的时间值
  const showTime = date.getTime(); // 展示时间对应的时间戳
  const nowDate = new Date(); // 当前日期
  const nowYear = nowDate.getFullYear();
  const nowDay = nowDate.getDate();
  const nowMonth = nowDate.getMonth() + 1;
  const nowStartDate = new Date(nowYear, nowMonth - 1, nowDay, 0, 0, 0); // 今天开始时间 从0点算起
  const yesStartDate = nowStartDate.getTime() - 24 * 60 * 60 * 1000; // 昨天开始时间 今天开始时间-1天
  const config = [
    { condition: showTime >= nowStartDate, res: `今天 ${result[1][0]}:${result[1][1]}`, result: '今天' },
    { condition: showTime > yesStartDate, res: `昨天 ${result[1][0]}:${result[1][1]}`, result: '昨天' },
  ];
  const trueArr = config.filter((item) => item.condition);
  if (trueArr.length > 0) {
    if (isOnlyData) { return trueArr[0].result; }
    return trueArr[0].res;
  }
  const year = Number(result[0][0]);
  if (nowYear === year || showTime < 0) {
    // 月-日 时:分
    const timeFirst = `${result[0][1]}-${result[0][2]} ${result[1][0]}:${result[1][1]}`;
    const timeSecond = `${result[0][1]}月${result[0][2]}日`;
    resTime = isOnlyData ? timeSecond : timeFirst;
  } else {
    const timeOne = `${year}-${result[0][1]}-${result[0][2]} ${result[1][0]}:${result[1][1]}`;
    const timeTwo = `${year}-${result[0][1]}-${result[0][2]}`;
    resTime = isOnlyData ? timeTwo : timeOne;
  }
  if (showTime < 0) { resTime = '今天'; }
  return resTime;
}

// 时间处理成 天时分秒
function formatTime(time) {
  const now = new Date().getTime();
  const totalSeconds = parseInt(String((time - now) / 1000), 10);
  if (totalSeconds > 0) {
    // 天数
    const days = Math.floor(totalSeconds / (60 * 60 * 24));
    // 取模（余数）
    let modulo = totalSeconds % (60 * 60 * 24);
    // 小时数
    const hours = Math.floor(modulo / (60 * 60));
    modulo %= (60 * 60);
    // 分钟
    const minutes = Math.floor(modulo / 60);
    // 秒
    const seconds = modulo % 60;

    return {
      isFinishCountDown: false,
      timeDownArray: [
        {
          value: days > 9 ? days : `0${days}`,
          unit: '天',
        },
        {
          value: hours > 9 ? hours : `0${hours}`,
          unit: '时',
        },
        {
          value: minutes > 9 ? minutes : `0${minutes}`,
          unit: '分',
        },
        {
          value: seconds > 9 ? seconds : `0${seconds}`,
          unit: '秒',
        },
      ],
    };
  }
  return {
    isFinishCountDown: true,
    timeDownArray: [
      {
        value: '00',
        unit: '天',
      },
      {
        value: '00',
        unit: '时',
      },
      {
        value: '00',
        unit: '分',
      },
      {
        value: '00',
        unit: '秒',
      },
    ],
  };
}

// 获取两日期之间的天数
function getDaysBetween(date1, date2) {
  const dateTime1 = Date.parse(date1.replace(/-/g, '/'));
  const dateTime2 = Date.parse(date2.replace(/-/g, '/'));
  return Math.floor(Math.abs(dateTime1 - dateTime2) / (24 * 60 * 60 * 1000));
}

// 获取指定日期前一天 yyyy-mm-dd
function getYesterday(date) {
  const oneDay = 24 * 60 * 60 * 1000;
  const dateTime = Date.parse(date.replace(/-/g, '/'));
  const yesterday = new Date(dateTime - oneDay);
  const year = yesterday.getFullYear();
  const month = yesterday.getMonth() + 1 < 10
    ? `0${yesterday.getMonth() + 1}`
    : yesterday.getMonth() + 1;
  const dateText = yesterday.getDate();
  return `${year}-${month}-${dateText}`;
}

function getRiskLevel(level) {
  if (isEmpty(level)) {
    return '--';
  }
  const risk = level === '--' || level === ''
    ? '低风险'
    : `${['低', '中低', '中', '中高', '高'][level - 1]}风险`;
  return risk;
}

// 判断时间是否过期
function judgeTimeIsExpired(time) {
  if (isEmpty(time)) { return false; }
  // 时间
  const date = new Date(time.replace('/-/g', '/'));
  // 现在时间
  const now = new Date();
  // 判断时间是否过期
  return date > now;
}

function getUnit(value) {
  numeral.cash([
    {
      amount: 10000,
      unit: '万',
      isLock: false, // 如果希望10000以下都有万单位，设置isLock:true
    },
    {
      amount: 100000000,
      unit: '亿',
    },
  ]);
  return numeral(value).format('0A', Math.round);
}

function highEndFundColor(value) {
  const num = parseFloat(value);
  if (num > 0) { return '#F24800'; }
  if (num < 0) { return '#12B412'; }
  return '#000000';
}

// 格式化天数
function formatDays(days) {
  if (!isEmpty(days)) {
    const daysInt = parseInt(days, 10);
    if (daysInt < 365) {
      return `${daysInt}天`;
    }
    if (daysInt === 365) {
      return '1年';
    }
    return `${parseInt(String(daysInt / 365.0), 10)}年又${daysInt % 365}天`;
  }
  return '--';
}

// 按规则重写查询参数的键名
function applyQueryMapping(rawParam, mapRule) {
  if (!rawParam) return '';
  const search = new URLSearchParams(rawParam);
  if (mapRule) {
    mapRule.split(',').map((s) => s.trim()).filter(Boolean).forEach((pair) => {
      const [from, to] = pair.split(':').map((p) => p?.trim()).filter(Boolean);
      if (from && to && search.has(from)) {
        const value = search.get(from);
        search.delete(from);
        if (value !== null) {
          search.set(to, value);
        }
      }
    });
  }
  return search.toString();
}

function hasRequiredQuery(paramStr, required) {
  if (!required) return true;
  const search = new URLSearchParams(paramStr || '');
  return required
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean)
    .every((key) => {
      const v = search.get(key);
      return v !== null && v !== '';
    });
}

/**
 * 从 fund 协议 URL 中解析 appId、path、params
 * 示例: fund://mp.1234567.com.cn/weex/fund8791fabebcf94b/pages/index?a=1&b=2
 * @param {string} url - 完整 URL 字符串
 * @returns {{ appId: string, path: string, params: string}}
 */
function parseFundJumpUrl(url) {
  if (!url || typeof url !== 'string') return {};
  // weex/ 后的 [^/]+ 为 appId，接着的 /xxx 到 ? 前为 path，? 后为 query
  const re = /weex\/([^/]+)(\/[^?]*)?(?:\?(.*))?$/;
  const match = url.match(re);
  if (!match) return {};
  const [, appId, path = '', queryStr] = match;
  return { appId, path, params: queryStr };
}

function getJumpUrl(url) {
  const { appId = '', path = '', params = '' } = parseFundJumpUrl(url);
  console.log('appID', appId, path, params);
  // 先拿缓存数据
  const isProd = window.location.hostname.indexOf('test') === -1;
  const storage = window.localStorage.getItem(`wxjumpconfig-${isProd ? 'prod' : 'test'}`) || {};
  let content = [];
  try {
    content = JSON.parse(storage)?.content ?? [];
  } catch (error) {
    return url;
  }
  // 检查跳转地址的path是否在白名单
  const whiteListTarget = content.find((c) => c.mpPath.includes(path) && c.mpPath.includes(appId));
  if (isEmpty(whiteListTarget)) {
    return url;
  }
  const {
    type, wxPath, checkQuery, query,
  } = whiteListTarget;
  // 检查查询串里是否包含所有必填参数且非空
  const passCheck = hasRequiredQuery(params, checkQuery);
  if (!passCheck) { return url; }
  // 参数映射
  const converted = applyQueryMapping(params, query);
  // 在白名单先判断类型
  if (type === 'h5') {
    const RELEASE_HOST = 'https://tradeh5.tiantianfunds.cn'; // 正式域名
    const TEST_HOST = 'https://tradeh5test.tiantianfunds.cn'; // 测试域名
    // 如果是h5就拼wxPath
    return `${isProd ? RELEASE_HOST : TEST_HOST}${wxPath}${converted ? `?${converted}` : ''}`;
  }
  // 微信环境下用微信的方法跳
  return `${wxPath}${converted ? `?${converted}` : ''}`;
}

function goDetail(source, goFundApp) {
  console.log('source>', source, 'convertUrl>', getJumpUrl(source));
  if (multi.$system.webPlatform === 'wxmp') {
    const convertUrl = getJumpUrl(source);
    console.log('source === convertUrl ???', source === convertUrl);
    if (source !== convertUrl) {
      wx.miniProgram.navigateTo({
        url: convertUrl,
      });
      return;
    }
  }
  goFundApp();
}

export default {
  getWeekFromDate,
  splitDateTime,
  getRateColor,
  hexToRgba,
  getDaysToNow,
  formateBigNumber,
  formateFixedNumber,
  formatDateTime,
  formatTime,
  getDaysBetween,
  getYesterday,
  getRiskLevel,
  judgeTimeIsExpired,
  getUnit,
  highEndFundColor,
  formatDays,
  applyQueryMapping,
  hasRequiredQuery,
  parseFundJumpUrl,
  getJumpUrl,
  goDetail,
};
